import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "loadingContainer"
};
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "flex flex-row gap-4 width-[60%] float-right justify-end items-end" };
const _hoisted_4 = { class: "activityTimelineContainer" };
const _hoisted_5 = ["id"];
const _hoisted_6 = { class: "mb-5" };
import { activityLogFilterLabels, activityLogFilterValues, } from '@/helper/helper';
import AppState, { setViewActivityLog } from '@/states/view_appointment';
import { UIContentWrap, UIDatepicker, UIModal, UIModalContent, UIModalHeader, UISelect, UISpin, } from '@gohighlevel/ghl-ui';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ActivityTimeline from './ActivityTimeline.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ViewActivityLog',
    props: {
        isLoading: Boolean,
        range: [Number, Number],
        onDateChange: Function,
        activityTimeLine: Object,
        timezone: String,
    },
    setup(__props) {
        const { t } = useI18n();
        const selectedFilter = ref('');
        const activityLogFilter = computed(() => {
            const fieldLabels = activityLogFilterLabels(t);
            const options = activityLogFilterValues.map(field => ({
                label: fieldLabels[field],
                value: field,
            }));
            return [
                {
                    label: t('activity_log.all'),
                    value: '',
                },
                ...options,
            ];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), null, {
                default: _withCtx(() => [
                    _createVNode(_unref(UIModal), {
                        show: _unref(AppState).viewActivityLog,
                        width: 860
                    }, {
                        header: _withCtx(() => [
                            _createVNode(_unref(UIModalHeader), {
                                title: _unref(t)('activity_log.activity_log'),
                                onClose: _cache[0] || (_cache[0] = ($event) => (_unref(setViewActivityLog)(false))),
                                id: "activity-log-modal-header"
                            }, null, 8 /* PROPS */, ["title"])
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_unref(UIModalContent), { class: "p-0 h-[700px]" }, {
                                default: _withCtx(() => [
                                    (__props.isLoading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                            _createVNode(_unref(UISpin))
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (!__props.isLoading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createCommentVNode(" Top Section : Date Picker to select ate based on the range "),
                                                _createVNode(_unref(UIDatepicker), {
                                                    id: "activity-log-date-picker",
                                                    type: "daterange",
                                                    class: "w-72",
                                                    "onUpdate:value": _cache[1] || (_cache[1] = val => __props.onDateChange(val)),
                                                    defaultValue: __props.range
                                                }, null, 8 /* PROPS */, ["defaultValue"]),
                                                _createCommentVNode(" Drodown to apply filter to view activity logs "),
                                                _createVNode(_unref(UISelect), {
                                                    options: activityLogFilter.value,
                                                    id: "activity-log-filter",
                                                    class: "w-64",
                                                    value: selectedFilter.value,
                                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((selectedFilter).value = $event))
                                                }, null, 8 /* PROPS */, ["options", "value"])
                                            ]),
                                            _createCommentVNode(" Bottom Section : Mapping the Activity Logs "),
                                            _createElementVNode("div", _hoisted_4, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activityTimeLine, (logs, date) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: date }, [
                                                        _createCommentVNode(" Map the Date for the activity "),
                                                        (!selectedFilter.value ||
                                                            logs.some(section => { var _a; return (_a = section.fields) === null || _a === void 0 ? void 0 : _a.includes(selectedFilter.value); }))
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                id: `activity-timeline-${date}`,
                                                                class: "date"
                                                            }, _toDisplayString(date), 9 /* TEXT, PROPS */, _hoisted_5))
                                                            : _createCommentVNode("v-if", true),
                                                        _createElementVNode("div", _hoisted_6, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs, (section, index) => {
                                                                return (_openBlock(), _createBlock(ActivityTimeline, {
                                                                    key: index,
                                                                    "change-label": section.changeLabel,
                                                                    "created-at": section.createdAt,
                                                                    from: section.from,
                                                                    to: section.to,
                                                                    source: section.source,
                                                                    "user-name": section.userName,
                                                                    "filter-option": selectedFilter.value,
                                                                    fields: section.fields,
                                                                    type: section.type,
                                                                    "current-values": section.currentValues,
                                                                    timezone: __props.timezone,
                                                                    index: index
                                                                }, null, 8 /* PROPS */, ["change-label", "created-at", "from", "to", "source", "user-name", "filter-option", "fields", "type", "current-values", "timezone", "index"]));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ])
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["show"])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
